module.exports = __webpack_public_path__ + "static/img/auth-side-panel-img2.bc6abb84.png";